import PropTypes from 'prop-types';
import cx from 'classnames';

import withTheme from 'core/hocs/withTheme';
import { withBrandingState } from 'core/components/Ad/BrandingContext';

import styles from './index.styl';


function FullWidth(props) {
  const {
    children,
    className,
    ignoreLayoutIndents,
    shift,
    theme,
    brandingState: {
      rendered,
    },
  } = props;

  return (
    <div
      className={cx(
        className,
        styles.fullwidth,
        ignoreLayoutIndents && '_ignoreLayoutIndents',
        rendered && styles._hasBranding,
      )}
    >
      <style jsx>{`
        .${styles.fullwidth}
          left ${shift}px

          @media screen and (max-width: ${theme.layout.minWidth})
            min-width ${theme.layout.minWidth}
            margin-left -${theme.layout.indents.left}px
            left 0
            &._ignoreLayoutIndents
              margin-left 0
      `}</style>
      {children}
    </div>
  );
}

FullWidth.propTypes = {
  /**
   * Смещение блока относительно левого края для случаев,
   * когда родительский блок компонента расположен не по центру
   * вьюпорта. Как правило, это половина расстояния между центром
   * блока и центром вьюпорта.
   */
  shift: PropTypes.number,

  /**
   * Отключает поправку на `theme.layout.indents.left`
   * при ширине экрана меньше `theme.layout.minWidth`
   */
  ignoreLayoutIndents: PropTypes.bool,

  brandingState: PropTypes.object,
  className: PropTypes.string,
  theme: PropTypes.object,
};

FullWidth.defaultProps = {
  shift: 0,
};

export default withTheme(withBrandingState(FullWidth));
